module.exports = __webpack_public_path__ + "static/osinowo-9cffa98ec23b36ba57378ee82633dea7.png";